module.exports = __webpack_public_path__ + "img/aboutApp2.f734ddf1.png";